// extracted by mini-css-extract-plugin
export default {"container":"style_container__iW+EN","header":"style_header__Qn-fa","main":"style_main__nAMRV","right":"style_right__+Sk9X"};